export const apiResponseHandler = (rawResponse) => {
  let messages;

  if (!rawResponse) {
    messages = [
      {
        type: 8,
        message: "پاسخی از سرور دریافت نشد",
      },
    ];
  } else if (rawResponse.status !== 200) {
    switch (rawResponse.status) {
      case 404:
        messages = [
          {
            type: 8,
            message: "آدرس درخواستی وجود ندارد",
          },
        ];
        break;
      case 500:
        messages = [
          {
            type: 8,
            message: "پردازش درخواست در سمت سرور با خطا مواجه شده است.",
          },
        ];
        break;
      case 401:
        messages = [
          {
            type: 8,
            message: "خطای عدم دسترسی",
          },
        ];
        break;
      default:
        if (rawResponse.data.messages) messages = rawResponse.data.messages;
        break;
    }
  } else if (
    rawResponse &&
    rawResponse.data &&
    "isSucceed" in rawResponse.data
  ) {
    return rawResponse.data;
  } else if (
    rawResponse.data.messages &&
    rawResponse.data.messages.length > 0
  ) {
    messages = rawResponse.data.messages;
  } else if (
    rawResponse.data.captchaInputText &&
    rawResponse.data.captchaInputText.errors.length > 0
  ) {
    messages = [
      {
        type: 8,
        message: rawResponse.data.captchaInputText.errors[0],
      },
    ];
  } else {
    messages = [
      {
        type: 8,
        message: "متاسفانه خطایی پیش آمده است",
      },
    ];
  }

  return {
    isSucceed: false,
    messages: messages,
  };
};
